function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function _403() {
  return import(/* webpackChunkName: "page-403" */ '@/pages/403.vue')
}
function _404() {
  return import(/* webpackChunkName: "page-404" */ '@/pages/404.vue')
}
function logout() {
  return import(/* webpackChunkName: "page-logout" */ '@/pages/logout.vue')
}
function recent_traffic() {
  return import(
    /* webpackChunkName: "page-recent_traffic" */ '@/pages/recent_traffic.vue'
  )
}
function profile_index() {
  return import(
    /* webpackChunkName: "page-profile-index" */ '@/pages/profile/index.vue'
  )
}
function customer_content_filtering() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering" */ '@/pages/customer/content_filtering.vue'
  )
}
function customer_content_filtering_block_page() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-block_page" */ '@/pages/customer/content_filtering/block_page.vue'
  )
}
function customer_content_filtering_cloud_keys_index() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-cloud_keys-index" */ '@/pages/customer/content_filtering/cloud_keys/index.vue'
  )
}
function customer_content_filtering_domains_index() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-domains-index" */ '@/pages/customer/content_filtering/domains/index.vue'
  )
}
function customer_content_filtering_policies_index() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-policies-index" */ '@/pages/customer/content_filtering/policies/index.vue'
  )
}
function customer_content_filtering_cloud_keys__id() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-cloud_keys-id" */ '@/pages/customer/content_filtering/cloud_keys/_id.vue'
  )
}
function customer_content_filtering_domains__id() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-domains-id" */ '@/pages/customer/content_filtering/domains/_id.vue'
  )
}
function customer_content_filtering_policies__id_index() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-policies-id-index" */ '@/pages/customer/content_filtering/policies/_id/index.vue'
  )
}
function customer_content_filtering_policies__id_devices() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-policies-id-devices" */ '@/pages/customer/content_filtering/policies/_id/devices.vue'
  )
}
function customer_content_filtering_policies__id_domains() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-policies-id-domains" */ '@/pages/customer/content_filtering/policies/_id/domains.vue'
  )
}
function customer_content_filtering_policies__id_locations() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-policies-id-locations" */ '@/pages/customer/content_filtering/policies/_id/locations.vue'
  )
}
function customer_content_filtering_policies__id_notifications() {
  return import(
    /* webpackChunkName: "page-customer-content_filtering-policies-id-notifications" */ '@/pages/customer/content_filtering/policies/_id/notifications.vue'
  )
}
function customer_environment() {
  return import(
    /* webpackChunkName: "page-customer-environment" */ '@/pages/customer/environment.vue'
  )
}
function customer_environment_devices_index() {
  return import(
    /* webpackChunkName: "page-customer-environment-devices-index" */ '@/pages/customer/environment/devices/index.vue'
  )
}
function customer_environment_groups_index() {
  return import(
    /* webpackChunkName: "page-customer-environment-groups-index" */ '@/pages/customer/environment/groups/index.vue'
  )
}
function customer_environment_groups_ranking_index() {
  return import(
    /* webpackChunkName: "page-customer-environment-groups-ranking-index" */ '@/pages/customer/environment/groups-ranking/index.vue'
  )
}
function customer_environment_locations_index() {
  return import(
    /* webpackChunkName: "page-customer-environment-locations-index" */ '@/pages/customer/environment/locations/index.vue'
  )
}
function customer_environment_users_index() {
  return import(
    /* webpackChunkName: "page-customer-environment-users-index" */ '@/pages/customer/environment/users/index.vue'
  )
}
function customer_environment_devices__id() {
  return import(
    /* webpackChunkName: "page-customer-environment-devices-id" */ '@/pages/customer/environment/devices/_id.vue'
  )
}
function customer_environment_groups__id() {
  return import(
    /* webpackChunkName: "page-customer-environment-groups-id" */ '@/pages/customer/environment/groups/_id.vue'
  )
}
function customer_environment_locations__id() {
  return import(
    /* webpackChunkName: "page-customer-environment-locations-id" */ '@/pages/customer/environment/locations/_id.vue'
  )
}
function customer_environment_users__id() {
  return import(
    /* webpackChunkName: "page-customer-environment-users-id" */ '@/pages/customer/environment/users/_id.vue'
  )
}
function customer_overview() {
  return import(
    /* webpackChunkName: "page-customer-overview" */ '@/pages/customer/overview.vue'
  )
}
function customer_recent_traffic() {
  return import(
    /* webpackChunkName: "page-customer-recent_traffic" */ '@/pages/customer/recent_traffic.vue'
  )
}
function customer_reporting_index() {
  return import(
    /* webpackChunkName: "page-customer-reporting-index" */ '@/pages/customer/reporting/index.vue'
  )
}
function customer_settings_index() {
  return import(
    /* webpackChunkName: "page-customer-settings-index" */ '@/pages/customer/settings/index.vue'
  )
}
function profile_security() {
  return import(
    /* webpackChunkName: "page-profile-security" */ '@/pages/profile/security.vue'
  )
}
function msp_global_settings_index() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-index" */ '@/pages/msp/global_settings/index.vue'
  )
}
function msp_overview_index() {
  return import(
    /* webpackChunkName: "page-msp-overview-index" */ '@/pages/msp/overview/index.vue'
  )
}
function sales_msps_index() {
  return import(
    /* webpackChunkName: "page-sales-msps-index" */ '@/pages/sales/msps/index.vue'
  )
}
function system_global_settings_index() {
  return import(
    /* webpackChunkName: "page-system-global_settings-index" */ '@/pages/system/global_settings/index.vue'
  )
}
function system_overview_index() {
  return import(
    /* webpackChunkName: "page-system-overview-index" */ '@/pages/system/overview/index.vue'
  )
}
function customer_reporting_behavior_reports_index() {
  return import(
    /* webpackChunkName: "page-customer-reporting-behavior_reports-index" */ '@/pages/customer/reporting/behavior_reports/index.vue'
  )
}
function customer_reporting_blocked_reports_index() {
  return import(
    /* webpackChunkName: "page-customer-reporting-blocked_reports-index" */ '@/pages/customer/reporting/blocked_reports/index.vue'
  )
}
function customer_reporting_history_reports_index() {
  return import(
    /* webpackChunkName: "page-customer-reporting-history_reports-index" */ '@/pages/customer/reporting/history_reports/index.vue'
  )
}
function customer_reporting_security_reports_index() {
  return import(
    /* webpackChunkName: "page-customer-reporting-security_reports-index" */ '@/pages/customer/reporting/security_reports/index.vue'
  )
}
function customer_reporting_summary_index() {
  return import(
    /* webpackChunkName: "page-customer-reporting-summary-index" */ '@/pages/customer/reporting/summary/index.vue'
  )
}
function customer_reporting_trend_reports_index() {
  return import(
    /* webpackChunkName: "page-customer-reporting-trend_reports-index" */ '@/pages/customer/reporting/trend_reports/index.vue'
  )
}
function customer_settings_certificates() {
  return import(
    /* webpackChunkName: "page-customer-settings-certificates" */ '@/pages/customer/settings/certificates.vue'
  )
}
function customer_settings_device_configuration() {
  return import(
    /* webpackChunkName: "page-customer-settings-device_configuration" */ '@/pages/customer/settings/device_configuration.vue'
  )
}
function customer_settings_support() {
  return import(
    /* webpackChunkName: "page-customer-settings-support" */ '@/pages/customer/settings/support.vue'
  )
}
function customer_settings_administrators_index() {
  return import(
    /* webpackChunkName: "page-customer-settings-administrators-index" */ '@/pages/customer/settings/administrators/index.vue'
  )
}
function customer_settings_default_policy_index() {
  return import(
    /* webpackChunkName: "page-customer-settings-default_policy-index" */ '@/pages/customer/settings/default_policy/index.vue'
  )
}
function customer_settings_device_exceptions_index() {
  return import(
    /* webpackChunkName: "page-customer-settings-device_exceptions-index" */ '@/pages/customer/settings/device_exceptions/index.vue'
  )
}
function customer_settings_tools_index() {
  return import(
    /* webpackChunkName: "page-customer-settings-tools-index" */ '@/pages/customer/settings/tools/index.vue'
  )
}
function login_TwoFaSetup_TwoFaSetup() {
  return import(
    /* webpackChunkName: "page-login-TwoFaSetup-TwoFaSetup" */ '@/pages/login/TwoFaSetup/TwoFaSetup.vue'
  )
}
function msp_global_settings_certificates() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-certificates" */ '@/pages/msp/global_settings/certificates.vue'
  )
}
function msp_global_settings_email_settings() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-email_settings" */ '@/pages/msp/global_settings/email_settings.vue'
  )
}
function msp_global_settings_global_block_page() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-global_block_page" */ '@/pages/msp/global_settings/global_block_page.vue'
  )
}
function msp_global_settings_global_default_policy() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-global_default_policy" */ '@/pages/msp/global_settings/global_default_policy.vue'
  )
}
function msp_global_settings_interface() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-interface" */ '@/pages/msp/global_settings/interface.vue'
  )
}
function msp_global_settings_security_settings() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-security_settings" */ '@/pages/msp/global_settings/security_settings.vue'
  )
}
function msp_global_settings_support() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-support" */ '@/pages/msp/global_settings/support.vue'
  )
}
function msp_global_settings_administrators_index() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-administrators-index" */ '@/pages/msp/global_settings/administrators/index.vue'
  )
}
function msp_global_settings_global_domains_index() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-global_domains-index" */ '@/pages/msp/global_settings/global_domains/index.vue'
  )
}
function msp_global_settings_tools_index() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-tools-index" */ '@/pages/msp/global_settings/tools/index.vue'
  )
}
function system_global_settings_certificates() {
  return import(
    /* webpackChunkName: "page-system-global_settings-certificates" */ '@/pages/system/global_settings/certificates.vue'
  )
}
function system_global_settings_email_settings() {
  return import(
    /* webpackChunkName: "page-system-global_settings-email_settings" */ '@/pages/system/global_settings/email_settings.vue'
  )
}
function system_global_settings_global_block_page() {
  return import(
    /* webpackChunkName: "page-system-global_settings-global_block_page" */ '@/pages/system/global_settings/global_block_page.vue'
  )
}
function system_global_settings_global_default_policy() {
  return import(
    /* webpackChunkName: "page-system-global_settings-global_default_policy" */ '@/pages/system/global_settings/global_default_policy.vue'
  )
}
function system_global_settings_interface() {
  return import(
    /* webpackChunkName: "page-system-global_settings-interface" */ '@/pages/system/global_settings/interface.vue'
  )
}
function system_global_settings_support() {
  return import(
    /* webpackChunkName: "page-system-global_settings-support" */ '@/pages/system/global_settings/support.vue'
  )
}
function system_global_settings_administrators_index() {
  return import(
    /* webpackChunkName: "page-system-global_settings-administrators-index" */ '@/pages/system/global_settings/administrators/index.vue'
  )
}
function system_global_settings_global_domains_index() {
  return import(
    /* webpackChunkName: "page-system-global_settings-global_domains-index" */ '@/pages/system/global_settings/global_domains/index.vue'
  )
}
function system_global_settings_tools_index() {
  return import(
    /* webpackChunkName: "page-system-global_settings-tools-index" */ '@/pages/system/global_settings/tools/index.vue'
  )
}
function customer_settings_default_policy_devices() {
  return import(
    /* webpackChunkName: "page-customer-settings-default_policy-devices" */ '@/pages/customer/settings/default_policy/devices.vue'
  )
}
function customer_settings_default_policy_domains() {
  return import(
    /* webpackChunkName: "page-customer-settings-default_policy-domains" */ '@/pages/customer/settings/default_policy/domains.vue'
  )
}
function customer_settings_default_policy_locations() {
  return import(
    /* webpackChunkName: "page-customer-settings-default_policy-locations" */ '@/pages/customer/settings/default_policy/locations.vue'
  )
}
function customer_settings_default_policy_notifications() {
  return import(
    /* webpackChunkName: "page-customer-settings-default_policy-notifications" */ '@/pages/customer/settings/default_policy/notifications.vue'
  )
}
function customer_settings_device_exceptions_device_exception_rules() {
  return import(
    /* webpackChunkName: "page-customer-settings-device_exceptions-device_exception_rules" */ '@/pages/customer/settings/device_exceptions/device_exception_rules.vue'
  )
}
function customer_settings_tools_recategorize_domain() {
  return import(
    /* webpackChunkName: "page-customer-settings-tools-recategorize_domain" */ '@/pages/customer/settings/tools/recategorize_domain.vue'
  )
}
function msp_global_settings_tools_dns_lookup() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-tools-dns_lookup" */ '@/pages/msp/global_settings/tools/dns_lookup.vue'
  )
}
function msp_global_settings_tools_recategorize_domain() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-tools-recategorize_domain" */ '@/pages/msp/global_settings/tools/recategorize_domain.vue'
  )
}
function system_global_settings_tools_dns_lookup() {
  return import(
    /* webpackChunkName: "page-system-global_settings-tools-dns_lookup" */ '@/pages/system/global_settings/tools/dns_lookup.vue'
  )
}
function system_global_settings_tools_recategorize_domain() {
  return import(
    /* webpackChunkName: "page-system-global_settings-tools-recategorize_domain" */ '@/pages/system/global_settings/tools/recategorize_domain.vue'
  )
}
function customer_settings_administrators__id() {
  return import(
    /* webpackChunkName: "page-customer-settings-administrators-id" */ '@/pages/customer/settings/administrators/_id.vue'
  )
}
function msp_global_settings_administrators__id() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-administrators-id" */ '@/pages/msp/global_settings/administrators/_id.vue'
  )
}
function msp_global_settings_global_domains__id() {
  return import(
    /* webpackChunkName: "page-msp-global_settings-global_domains-id" */ '@/pages/msp/global_settings/global_domains/_id.vue'
  )
}
function system_global_settings_administrators__id() {
  return import(
    /* webpackChunkName: "page-system-global_settings-administrators-id" */ '@/pages/system/global_settings/administrators/_id.vue'
  )
}
function system_global_settings_global_domains__id() {
  return import(
    /* webpackChunkName: "page-system-global_settings-global_domains-id" */ '@/pages/system/global_settings/global_domains/_id.vue'
  )
}
function msp_overview__id() {
  return import(
    /* webpackChunkName: "page-msp-overview-id" */ '@/pages/msp/overview/_id.vue'
  )
}
function sales_msps__id() {
  return import(
    /* webpackChunkName: "page-sales-msps-id" */ '@/pages/sales/msps/_id.vue'
  )
}
function system_overview__id() {
  return import(
    /* webpackChunkName: "page-system-overview-id" */ '@/pages/system/overview/_id.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
  },
  {
    name: '403',
    path: '403',
    component: _403,
  },
  {
    name: '404',
    path: '404',
    component: _404,
  },
  {
    name: 'logout',
    path: 'logout',
    component: logout,
  },
  {
    name: 'Recent Traffic',
    path: 'recent_traffic',
    component: recent_traffic,
  },
  {
    name: 'Profile',
    path: 'profile',
    component: profile_index,
    redirect: '/profile/security',
  },
  {
    name: 'Customer Content Filtering',
    path: 'customer/content_filtering',
    component: customer_content_filtering,
    meta: {
      authorize: [1, 3, 4],
    },
    redirect: '/customer/content_filtering/policies',
    children: [
      {
        name: 'Customer Block Page',
        path: 'block_page',
        component: customer_content_filtering_block_page,
      },
      {
        name: 'Customer Cloud Keys',
        path: 'cloud_keys',
        component: customer_content_filtering_cloud_keys_index,
      },
      {
        name: 'Customer Domains',
        path: 'domains',
        component: customer_content_filtering_domains_index,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Policies',
        path: 'policies',
        component: customer_content_filtering_policies_index,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'customer-content_filtering-cloud_keys-id',
        path: 'cloud_keys/:id?',
        component: customer_content_filtering_cloud_keys__id,
      },
      {
        name: 'Customer Domain Detail',
        path: 'domains/:id?',
        component: customer_content_filtering_domains__id,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Policy',
        path: 'policies/:id',
        component: customer_content_filtering_policies__id_index,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Devices',
        path: 'policies/:id/devices',
        component: customer_content_filtering_policies__id_devices,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Allowed & Blocked Domains',
        path: 'policies/:id/domains',
        component: customer_content_filtering_policies__id_domains,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Locations',
        path: 'policies/:id/locations',
        component: customer_content_filtering_policies__id_locations,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Notifications',
        path: 'policies/:id/notifications',
        component: customer_content_filtering_policies__id_notifications,
        meta: {
          authorize: [1, 3, 4],
        },
      },
    ],
  },
  {
    name: 'Customer Environment',
    path: 'customer/environment',
    component: customer_environment,
    meta: {
      authorize: [1, 3, 4],
    },
    redirect: '/customer/environment/locations',
    children: [
      {
        name: 'Customer Environment Devices',
        path: 'devices',
        component: customer_environment_devices_index,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Groups',
        path: 'groups',
        component: customer_environment_groups_index,
      },
      {
        name: 'Customer Ranking Groups',
        path: 'groups-ranking',
        component: customer_environment_groups_ranking_index,
      },
      {
        name: 'Customer Environment Locations',
        path: 'locations',
        component: customer_environment_locations_index,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Users',
        path: 'users',
        component: customer_environment_users_index,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Environment Device',
        path: 'devices/:id?',
        component: customer_environment_devices__id,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer Group',
        path: 'groups/:id?',
        component: customer_environment_groups__id,
      },
      {
        name: 'Customer Environment Location',
        path: 'locations/:id?',
        component: customer_environment_locations__id,
        meta: {
          authorize: [1, 3, 4],
        },
      },
      {
        name: 'Customer User',
        path: 'users/:id?',
        component: customer_environment_users__id,
      },
    ],
  },
  {
    name: 'Customer Overview',
    path: 'customer/overview',
    component: customer_overview,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Recent Traffic',
    path: 'customer/recent_traffic',
    component: customer_recent_traffic,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'customer settings',
    path: 'customer/reporting',
    component: customer_reporting_index,
    meta: {
      authorize: [1, 3, 4],
    },
    redirect: '/customer/reporting/summary',
  },
  {
    name: 'Customer Settings',
    path: 'customer/settings',
    component: customer_settings_index,
    meta: {
      authorize: [1, 3, 4],
    },
    redirect: '/customer/settings/administrators',
  },
  {
    name: 'Security',
    path: 'profile/security',
    component: profile_security,
  },
  {
    name: 'MSP Global Settings',
    path: 'msp/global_settings',
    component: msp_global_settings_index,
    redirect: '/msp/global_settings/administrators',
  },
  {
    name: 'MSP Overview',
    path: 'msp/overview',
    component: msp_overview_index,
    meta: {
      authorize: [1, 2, 3],
    },
  },
  {
    name: 'Sales Managed Service Providers',
    path: 'sales/msps',
    component: sales_msps_index,
    meta: {
      authorize: [1, 2],
    },
  },
  {
    name: 'System Global Settings',
    path: 'system/global_settings',
    component: system_global_settings_index,
    redirect: '/system/global_settings/administrators',
  },
  {
    name: 'System Overview',
    path: 'system/overview',
    component: system_overview_index,
    meta: {
      authorize: [1, 2],
    },
  },
  {
    name: 'Behavior Report',
    path: 'customer/reporting/behavior_reports',
    component: customer_reporting_behavior_reports_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Blocked Reports',
    path: 'customer/reporting/blocked_reports',
    component: customer_reporting_blocked_reports_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'History Reports',
    path: 'customer/reporting/history_reports',
    component: customer_reporting_history_reports_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Security Reports',
    path: 'customer/reporting/security_reports',
    component: customer_reporting_security_reports_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'summary',
    path: 'customer/reporting/summary',
    component: customer_reporting_summary_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Behavior Report',
    path: 'customer/reporting/trend_reports',
    component: customer_reporting_trend_reports_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Certificates',
    path: 'customer/settings/certificates',
    component: customer_settings_certificates,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Device Configuration',
    path: 'customer/settings/device_configuration',
    component: customer_settings_device_configuration,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Support',
    path: 'customer/settings/support',
    component: customer_settings_support,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Administrators',
    path: 'customer/settings/administrators',
    component: customer_settings_administrators_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Default Policy',
    path: 'customer/settings/default_policy',
    component: customer_settings_default_policy_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Device Exceptions',
    path: 'customer/settings/device_exceptions',
    component: customer_settings_device_exceptions_index,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Test Categorization',
    path: 'customer/settings/tools',
    component: customer_settings_tools_index,
  },
  {
    name: 'login-TwoFaSetup-TwoFaSetup',
    path: 'login/TwoFaSetup/TwoFaSetup',
    component: login_TwoFaSetup_TwoFaSetup,
  },
  {
    name: 'msp-global_settings-certificates',
    path: 'msp/global_settings/certificates',
    component: msp_global_settings_certificates,
  },
  {
    name: 'msp-global_settings-email_settings',
    path: 'msp/global_settings/email_settings',
    component: msp_global_settings_email_settings,
  },
  {
    name: 'MSP Block Page',
    path: 'msp/global_settings/global_block_page',
    component: msp_global_settings_global_block_page,
  },
  {
    name: 'MSP Global Policy',
    path: 'msp/global_settings/global_default_policy',
    component: msp_global_settings_global_default_policy,
  },
  {
    name: 'MSP Interface Settings',
    path: 'msp/global_settings/interface',
    component: msp_global_settings_interface,
  },
  {
    name: 'msp-global_settings-security_settings',
    path: 'msp/global_settings/security_settings',
    component: msp_global_settings_security_settings,
  },
  {
    name: 'MSP Global Support',
    path: 'msp/global_settings/support',
    component: msp_global_settings_support,
  },
  {
    name: 'MSP Administrators',
    path: 'msp/global_settings/administrators',
    component: msp_global_settings_administrators_index,
  },
  {
    name: 'MSP Global Domains',
    path: 'msp/global_settings/global_domains',
    component: msp_global_settings_global_domains_index,
  },
  {
    name: 'MSP Global Test Categorization',
    path: 'msp/global_settings/tools',
    component: msp_global_settings_tools_index,
  },
  {
    name: 'system-global_settings-certificates',
    path: 'system/global_settings/certificates',
    component: system_global_settings_certificates,
  },
  {
    name: 'system-global_settings-email_settings',
    path: 'system/global_settings/email_settings',
    component: system_global_settings_email_settings,
  },
  {
    name: 'System Global Block Page',
    path: 'system/global_settings/global_block_page',
    component: system_global_settings_global_block_page,
  },
  {
    name: 'System Global Policy',
    path: 'system/global_settings/global_default_policy',
    component: system_global_settings_global_default_policy,
  },
  {
    name: 'System Interface Settings',
    path: 'system/global_settings/interface',
    component: system_global_settings_interface,
  },
  {
    name: 'System Global Support',
    path: 'system/global_settings/support',
    component: system_global_settings_support,
  },
  {
    name: 'System Administrators',
    path: 'system/global_settings/administrators',
    component: system_global_settings_administrators_index,
  },
  {
    name: 'System Global Domains',
    path: 'system/global_settings/global_domains',
    component: system_global_settings_global_domains_index,
  },
  {
    name: 'System Global Test Categorization',
    path: 'system/global_settings/tools',
    component: system_global_settings_tools_index,
  },
  {
    name: 'Customer Default Devices',
    path: 'customer/settings/default_policy/devices',
    component: customer_settings_default_policy_devices,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'customer-settings-default_policy-domains',
    path: 'customer/settings/default_policy/domains',
    component: customer_settings_default_policy_domains,
  },
  {
    name: 'Customer Default Locations',
    path: 'customer/settings/default_policy/locations',
    component: customer_settings_default_policy_locations,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Default Notifications',
    path: 'customer/settings/default_policy/notifications',
    component: customer_settings_default_policy_notifications,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Device Exception Rules',
    path: 'customer/settings/device_exceptions/device_exception_rules',
    component: customer_settings_device_exceptions_device_exception_rules,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'Customer Recategorize Domain',
    path: 'customer/settings/tools/recategorize_domain',
    component: customer_settings_tools_recategorize_domain,
  },
  {
    name: 'MSP DNS Lookup',
    path: 'msp/global_settings/tools/dns_lookup',
    component: msp_global_settings_tools_dns_lookup,
  },
  {
    name: 'MSP Global Recategorize Domain',
    path: 'msp/global_settings/tools/recategorize_domain',
    component: msp_global_settings_tools_recategorize_domain,
  },
  {
    name: 'System DNS Lookup',
    path: 'system/global_settings/tools/dns_lookup',
    component: system_global_settings_tools_dns_lookup,
  },
  {
    name: 'System Global Recategorize Domain',
    path: 'system/global_settings/tools/recategorize_domain',
    component: system_global_settings_tools_recategorize_domain,
  },
  {
    name: 'Customer Administrator',
    path: 'customer/settings/administrators/:id?',
    component: customer_settings_administrators__id,
    meta: {
      authorize: [1, 3, 4],
    },
  },
  {
    name: 'MSP Administrator',
    path: 'msp/global_settings/administrators/:id?',
    component: msp_global_settings_administrators__id,
  },
  {
    name: 'MSP Global Domain Details',
    path: 'msp/global_settings/global_domains/:id?',
    component: msp_global_settings_global_domains__id,
  },
  {
    name: 'System Administrator',
    path: 'system/global_settings/administrators/:id?',
    component: system_global_settings_administrators__id,
  },
  {
    name: 'Global Domain Details',
    path: 'system/global_settings/global_domains/:id?',
    component: system_global_settings_global_domains__id,
  },
  {
    name: 'MSP Customer',
    path: 'msp/overview/:id?',
    component: msp_overview__id,
  },
  {
    name: 'Sales MSP',
    path: 'sales/msps/:id?',
    component: sales_msps__id,
    meta: {
      authorize: [1, 2],
    },
  },
  {
    name: 'System Customer',
    path: 'system/overview/:id?',
    component: system_overview__id,
  },
]
